import { Injectable, signal, computed } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { HOURS_KEY, MINUTES_KEY } from '@nagel-consts';
import { SingleDateTimeValueType } from 'libs/nagel-types/src/lib/field-types';

@Injectable({ providedIn: 'root' })
export class SingleDateTimeService {
    private form!: FormGroup;

    private readonly _currentDateTime = signal<SingleDateTimeValueType>({
        date: null,
        time: {
            hours: '00',
            minutes: '00'
        }
    });

    readonly currentDateTime = computed(() => this._currentDateTime());

    setForm = (form: FormGroup) => {
        this.form = form;
        this.updateSignalFromForm();
    };

    getDateFormControl = () => {
        return this.form.get('date') as FormControl<Date | null>;
    };

    getTimeFormGroup = () => {
        return this.form.get('time') as FormGroup;
    };

    getHoursControl = () => {
        return this.getTimeFormGroup().get(HOURS_KEY) as FormControl<string>;
    };

    getMinutesControl = () => {
        return this.getTimeFormGroup().get(MINUTES_KEY) as FormControl<string>;
    };

    setDate = (date: Date | null) => {
        this.getDateFormControl().setValue(date);
        this.updateSignalFromForm();
    };

    resetForm = () => {
        this.form.reset({
            date: null,
            time: {
                hours: '00',
                minutes: '00'
            }
        });

        this.updateSignalFromForm();
    };

    private updateSignalFromForm = () => {
        const value = this.form?.getRawValue() as SingleDateTimeValueType;
        this._currentDateTime.set(value);
    };
}
